module.exports = __webpack_public_path__ + "static/media/anjum2.86cdce59.jpeg";